import { Entity } from "../helpers/Entity"
import PriceLevel, { PriceLevelDto } from "../price-level/PriceLevel"

type ProductPriceAttributesDto = {
    productId: string
    price: string
    priceLevel: PriceLevelDto
    priceLevelId: string
    isArchived: boolean
}

export type ProductPriceDto = {
    id: string
    type: string
    attributes: ProductPriceAttributesDto
}

export default class ProductPrice implements Entity {
    dto: ProductPriceDto
    priceLevel: PriceLevel
    constructor(dto: ProductPriceDto) {
        this.dto = dto
        this.priceLevel = new PriceLevel(dto?.attributes?.priceLevel)
    }

    isLoaded(): boolean {
        return this.dto.id != ""
    }

    getId(): string {
        return this.dto.id
    }

    getPriceLevelId(): string {
        return this.dto.attributes.priceLevelId
    }

    getProductId(): string {
        return this.dto.attributes.productId
    }

    getPrice(): string {
        return this.dto.attributes.price
    }

    getPriceLevelName(): string {
        return this.dto.attributes.priceLevel.attributes.name
    }   

    isArchived(): boolean {
        return this.dto.attributes.isArchived
    }
}


// WEBPACK FOOTER //
// ./src/state/product-price/ProductPrice.ts